import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { FETCH_TANENTS, TANENT_CREATE, TANENT_STATUS_CHANGE } from "constants/tanent.constants";
import axios from "axios";
import { getTanentsSuccess, onSubmitTanentActionSuccess } from "actions/tanent.action";
import { showErrors, stopLoader, setNotification } from "actions/general.action";

// get tanents info data
const fetchTanentRequest = async (page) => {
  // for this movement pagination not consider
  let link = "/api/v1/super_admin/tanents";
  return axios.get(link);
};

function* fetchTanents({ page }) {
  // for this movement pagination not consider
  try {
    const result = yield call(fetchTanentRequest, page);
    if (result.message) {
      yield put(showErrors(result.message));
    } else {
      yield put(getTanentsSuccess(result.data));
    }
  } catch (error) {
    yield put(showErrors(error.message));
  }
}

// create tanent
const createTanentRequest = async (tanent_data) => {
  return axios.post("/api/v1/super_admin/tanents", tanent_data);
};

function* createTanent({ tanent_data }) {
  let notification = {
    open: true,
    status: "",
    message: "",
  };
  try {
    const result = yield call(createTanentRequest, tanent_data);
    if (result.message) {
      notification.status = "error";
      notification.message = result.message;
    } else {
      const resultTanents = yield call(fetchTanentRequest);
      if (resultTanents.message) {
        notification.status = "error";
        notification.message = resultTanents.message;
      } else {
        notification.status = "success";
        notification.message = "Tanent Created";
        yield all([put(onSubmitTanentActionSuccess(resultTanents.data))]);
      }
    }
    yield put(stopLoader());
    yield put(setNotification(notification));
  } catch (error) {
    notification.status = "error";
    notification.message = error.message;
    yield put(stopLoader());
    yield put(setNotification(notification));
  }
}

// edit tanent
const updateTanentStatusRequest = async (anent_edit_data) => {
  const { id, status } = anent_edit_data;
  const tanent_status_change_object = {
    status: status,
  };
  return axios.put("/api/v1/super_admin/tanents/" + id, tanent_status_change_object);
};

function* updateTanentStatus({ tanent_edit_data }) {
  let notification = {
    open: true,
    status: "",
    message: "",
  };
  try {
    const reuslt = yield call(updateTanentStatusRequest, tanent_edit_data);
    if (reuslt.message) {
      notification.status = "error";
      notification.message = reuslt.message;
    } else {
      const resultTanents = yield call(fetchTanentRequest);
      if (resultTanents.message) {
        notification.status = "error";
        notification.message = resultTanents.message;
      } else {
        notification.status = "success";
        notification.message = "Tanent Updated";
        yield all([put(onSubmitTanentActionSuccess(resultTanents.data))]);
      }
    }
    yield put(stopLoader());
    yield put(setNotification(notification));
  } catch (error) {
    notification.status = "error";
    notification.message = error.message;
    yield put(stopLoader());
    yield put(setNotification(notification));
  }
}

export function* forkFetchTanents() {
  yield takeEvery(FETCH_TANENTS, fetchTanents);
}

export function* forkCreateTanent() {
  yield takeEvery(TANENT_CREATE, createTanent);
}

export function* forkUpdateTanentStatus() {
  yield takeEvery(TANENT_STATUS_CHANGE, updateTanentStatus);
}

export default function* rootSaga() {
  yield all([fork(forkFetchTanents), fork(forkCreateTanent), fork(forkUpdateTanentStatus)]);
}
